import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'libraries/ui_card/card.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { VehicleRentalStepComponent } from "./vehicle-rental-step.component";
import { PickCarInformationsModule } from "../../../rental/car/pick-car-informations/pick-car-informations.module";
import { CarTitleModule } from "../../../rental/car/car-title/car-title.module";
import { PriceModule } from "../../../price/price.module";
import { BlockCarModalContactModule } from "../../../rental/car/block-car-modal-contact/block-car-modal-contact.module";

@NgModule({
    declarations: [
        VehicleRentalStepComponent
    ],
    imports: [
        CommonModule,
        CardModule,
        BtnModule,
        PickCarInformationsModule,
        CarTitleModule,
        PriceModule,
        BlockCarModalContactModule
    ],
    exports: [
        VehicleRentalStepComponent
    ]
})
export class VehicleRentalStepModule {}